// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154iidpf{top:0}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1ltvidpf{left:0}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._kqswstnw{position:absolute}\n._syazw5hi{color:var(--_1qgzj18)}\n._vr2wstnw span{position:absolute}", ""]);
// Exports
module.exports = exports;
